import React, { useContext, useRef } from 'react';
import { Field } from "formik";
import {
  HeadCoverage,
  TableComponent,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCollum,
  TableCollumCoverageName,
  SmallTitle,
  InlineLabel,
  AddButton,
  ContainerButton,
  TextButton
} from './styles'
import MasksHelper from 'utils/src/masks';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import Icon from 'components/Icon'
import { equals } from 'ramda';
import { GridColumnTitle, Label, CheckBox,InputField } from '@fitinsur/components';


const Table = ({ calcList, setFieldValue, addNewModality, show, calcListIndex, recalculatePlan, deleteModality, onChangeLmi, getIsCoefficient, setDialogHiddenQuestion, dialogHiddenQuestion, handleCheckCoverage }) => {
  const maskHelper = new MasksHelper();
  const authContext = useContext(GlobalAuthContext);
  const loading = useContext(GlobalLoaderContext);
  const isCoefficient = useRef(null);

  return (
    <>
      <TableComponent style={{ ...(show ? {} : { display: 'none' }) }}>
         <>
            <TableHead>
              <TableRow>
                <TableHeader minWidth={300} maxWidth={300}>
                  <SmallTitle>{calcList.productPlanName} </SmallTitle>
                </TableHeader>
                <TableHeader minWidth={100}><SmallTitle>IS</SmallTitle></TableHeader>
                <TableHeader><SmallTitle>PR. TÉCNICO</SmallTitle></TableHeader>
                <TableHeader minWidth={30}><SmallTitle>%</SmallTitle></TableHeader>
                <TableHeader><SmallTitle>PR. TÉCNICO AJUSTADO</SmallTitle></TableHeader>
                <TableHeader><SmallTitle>PR. LÍQUIDO</SmallTitle></TableHeader>
                <TableHeader style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                  <SmallTitle>FRANQUIA</SmallTitle>
                </TableHeader>
              </TableRow>
            </TableHead>
            <TableBody>
              {calcList.coverageItems.map((coverage, coverageIndex) => {
                return (
                  <TableRow key={`${calcListIndex}-${coverageIndex}`}>
                    <TableCollum width={'30%'}>
                      <TableCollumCoverageName>
                        <label>
                          <Field
                            component={CheckBox}
                            name={`calculationList.${calcListIndex}.coverageItems.${coverageIndex}.coverageDisabled`}
                            checkValue
                            reverseValue
                            onChange={(value) => {
                              loading.start();
                              setTimeout(() => {
                                handleCheckCoverage && handleCheckCoverage(value, coverage.idCoverage)
                                loading.stop();
                              }, 1000)
                            }} />
                        </label>
                        <div>{coverage.coverageName}</div>
                      </TableCollumCoverageName>
                    </TableCollum>
                    <TableCollum width={'12%'}>
                      <InlineLabel>
                        IS
                      </InlineLabel>
                      <Field
                        style={{ width: '100%' }}
                        mask={maskHelper.getMask("currency", authContext.region, 2, 12, 100000000000, 0)}
                        name={`calculationList.${calcListIndex}.coverageItems.${coverageIndex}.coverageLimit`}
                        component={InputField}
                        type="text"
                        validation={false}
                        disabled={true}
                        onChange={(value) => {
                          setFieldValue(`calculationList.${calcListIndex}.coverageItems.${coverageIndex}.coverageLimit`, value);
                        }}
                        />
                    </TableCollum>
                    <TableCollum width={'12%'}>
                      <InlineLabel>
                        PR. TÉCNICO
                      </InlineLabel>
                      <Field
                        style={{ width: '100%' }}
                        mask={maskHelper.getMask("currency", authContext.region, 2, 12, 100000000000, 0)}
                        name={`calculationList.${calcListIndex}.coverageItems.${coverageIndex}.coveragePremium`}
                        component={InputField}
                        type="text"
                        validation={false}
                        disabled={coverage.coverageDisabled}
                        readOnly={true}
                      />
                    </TableCollum>
                    <TableCollum width={'10%'}>
                      <InlineLabel>
                        %
                      </InlineLabel>
                      <Field
                        style={{ width: '100%' }}
                        name={`calculationList.${calcListIndex}.coverageItems.${coverageIndex}.coveragePremiumDiscountRate`}
                        component={InputField}
                        type="text"
                        validation={false}
                        disabled={coverage.coverageDisabled}
                        mask={maskHelper.getPercentage(authContext.region, 2, "1000", "-100")}
                      />
                    </TableCollum>
                    <TableCollum width={'12%'}>
                      <InlineLabel>
                        PR. TÉCNICO AJUSTADO
                      </InlineLabel>
                      <Field
                        style={{ width: '100%' }}
                        mask={maskHelper.getMask("currency", authContext.region, 2, 12, 100000000000, 0)}
                        name={`calculationList.${calcListIndex}.coverageItems.${coverageIndex}.coveragePremiumDiscountLess`}
                        component={InputField}
                        type="text"
                        validation={false}
                        disabled={coverage.coverageDisabled}
                        readOnly={true}
                      />
                    </TableCollum>
                    <TableCollum width={'12%'}>
                      <InlineLabel>
                        PR. LÍQUIDO
                      </InlineLabel>
                      <Field
                        style={{ width: '100%' }}
                        mask={maskHelper.getMask("currency", authContext.region, 2, 12, 100000000000, 0)}
                        name={`calculationList.${calcListIndex}.coverageItems.${coverageIndex}.coveragePremiumTaxLess`}
                        component={InputField}
                        type="text"
                        validation={false}
                        disabled={coverage.coverageDisabled}
                        readOnly={true}
                      />
                    </TableCollum>
                    <TableCollum width={'20%'}>
                      <InlineLabel>
                        FRANQUIA
                      </InlineLabel>
                      <Field
                        style={{ width: '100%' }}
                        mask={maskHelper.getMask("currency", authContext.region, 2, 12, 100000000000, 0)}
                        name={`calculationList.${calcListIndex}.coverageItems.${coverageIndex}.deductibleDescription`}
                        component={InputField}
                        type="text"
                        validation={false}
                        disabled={coverage.coverageDisabled}
                      />
                    </TableCollum>
                  </TableRow>
                )
              })}
            </TableBody>
          </>
        

      </TableComponent>
    </>
  )
}

const tablePropsDiff = (prevProps, nextProps) => {
  if (!equals(nextProps.calcList, prevProps.calcList) || nextProps.show !== prevProps.show) return false;
  return true;
}

export default React.memo(Table, tablePropsDiff);
